module.exports = __webpack_public_path__ + "static/media/facebook-4.793b810d.svg";